/**
 * Set with names of all customizable zones.
 */
export const CustomizableZone: Set<string> = new Set([
  'MainContainer',
  'Header',
  'MainMenu_Button',
  'MainMenu_Dropdown',
  'Header_Toolbar',
  'ToggleModeButton',
  'ResolutionSelect',
  'LocalizationSelect',
  'JsonViewButton',
  'ToggleThemeButton',
  'LeftPanel',
  'LeftPanel_Nav',
  'LeftPanel_Content',
  'Tree_Tab',
  'Tree_Tab_Content',
  'Components_Tab',
  'Components_Tab_Content',
  'Settings_Tab',
  'Settings_Tab_Content',
  'Forms_Tab',
  'Forms_Tab_Content',
  'CentralPanel',
  'FormContainer',
  'RightPanel',
  'RightPanel_Nav',
  'RightPanel_Content',
  'Main_Tab',
  'Main_Tab_Content',
  'Style_Tab',
  'Style_Tab_Content',
  'Actions_Tab',
  'Actions_Tab_Content',
  'Rules_Tab',
  'Rules_Tab_Content',
  'LabeledProperty',
  'PropertyCodeButton',
  'PropertyLabel',
  'PropertyInput',
])

/**
 * The available keys of the customizable components.
 */
export type CustomizableKey = typeof CustomizableZone extends Set<infer U> ? U : never;
